import React, { useEffect, useState } from 'react'
import { useHistory } from 'react-router-dom'
import { get } from 'lodash'
import { useSnackbar } from 'notistack'
import {
  Button,
  CircularProgress,
  Container,
  IconButton,
  TextField,
  Typography,
} from '@material-ui/core'
import KeyboardBackspaceIcon from '@material-ui/icons/KeyboardBackspace'
import AddIcon from '@material-ui/icons/Add'

import StepCard from '../../components/cards/StepCard/StepCard'
import useFormHooks from '../../components/hooks/useFormHooks'
import { fetchData } from '../../api/api'
import showTicketStyles from './css/showTicketStyles'

const ShowTicket = ({ location }) => {
  const classes = showTicketStyles()
  const history = useHistory()
  const { enqueueSnackbar } = useSnackbar()

  const searchData = get(location, 'state')
  const view = 'ticket'

  const [isLoading, setIsLoading] = useState(false)

  const handleNewTicketClick = () => {
    return history.push({
      pathname: 'generar-ticket',
    })
  }

  const initialState = {
    email: '',
  }

  const { handleSubmit, handleInputChange, inputs, clearInputs } = useFormHooks(
    initialState,
    async () => {
      setIsLoading(true)
      try {
        setIsLoading(false)

        return clearInputs()
      } catch (error) {
        enqueueSnackbar(
          get(error, 'response.data.error_description') || get(error, 'message') || '',
          {
            variant: 'error',
            autoHideDuration: 1000,
          }
        )
        setIsLoading(false)
        return error
      }
    }
  )

  return (
    <div className={classes.root}>
      <Container maxWidth="md" className={classes.container}>
        <div className={classes.headerContainer}>
          <div className={classes.buttonsContainer}>
            <IconButton
              className={classes.iconButton}
              onClick={() => {
                history.goBack()
              }}
            >
              <KeyboardBackspaceIcon className={classes.icon} />
            </IconButton>
            <Button
              color="inherit"
              size="large"
              variant="contained"
              onClick={handleNewTicketClick}
              endIcon={<AddIcon />}
              className={classes.newTicketButton}
            >
              NUEVO TICKET
            </Button>
          </div>

          <Typography color="inherit" align="left" variant="h5" className={classes.title}>
            ¡Tu ticket está listo!
          </Typography>
          <Typography color="inherit" align="left" variant="subtitle1" className={classes.subTitle}>
            Puedes descargarlo como PDF o enviarlo por e-mail
          </Typography>
          <Button
            fullWidth
            size="large"
            variant="contained"
            color="primary"
            onClick={() => {
              history.goBack()
            }}
            className={classes.downloadButton}
          >
            DESCARGAR TICKET
          </Button>
        </div>

        <StepCard hideSteps>
          <form className={classes.form} onSubmit={handleSubmit}>
            <Typography className={classes.boldFont} gutterBottom>
              Enviar ticket a:
            </Typography>
            <TextField
              required
              fullWidth
              label="Correo"
              variant="outlined"
              type="email"
              name="email"
              value={get(inputs, 'email')}
              onChange={handleInputChange}
              className={classes.textField}
            />
            <Button
              fullWidth
              size="large"
              variant="contained"
              color="primary"
              onClick={() => {
                history.goBack()
              }}
              style={{ height: 56 }}
            >
              {isLoading ? <CircularProgress /> : 'MANDAR CORREO'}
            </Button>
          </form>
        </StepCard>
      </Container>
    </div>
  )
}

export default ShowTicket
